// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 22H2V2H9V22ZM22 22H11V17H13V20H20V4H13V7H11V2H22V22ZM16.4141 9.5L13.9141 12L16.4141 14.5L15 15.9141L11.0859 12L15 8.08594L16.4141 9.5Z"}}]};

const ComponentStickytoolFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-stickytool-filled',
    ref,
    icon: element,
  },
));

ComponentStickytoolFilledIcon.displayName = 'ComponentStickytoolFilledIcon';

export default ComponentStickytoolFilledIcon;
